import { useState } from "react";
import { Link, useNavigate } from "react-router-dom"; // <- usamos useNavigate
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { logoutUser } from "../controller/userController"; // <- importa tu función logout
import './sidebar.css';

function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const [OpenCompany, setOpenCompany] = useState(false);
  const [openHorario, setOpenHorario] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const [openReport, setOpenReport] = useState(false);

  const navigate = useNavigate(); // <- hook para redirigir

  const handleToggle = (section) => {
    if (section === "Company") setOpenCompany(!OpenCompany);
    if (section === "Horario") setOpenHorario(!openHorario);
    if (section === "settings") setOpenSettings(!openSettings);
    if (section === "report") setOpenReport(!openReport);
  };

  const handleLogout = () => {
    logoutUser();         // Borra los tokens
    navigate("/");        // Redirige al login
  };

  return (
<div
  className="d-flex flex-column p-3 sidebar-custom"
  style={{
    width: collapsed ? "80px" : "250px",
    transition: "width 0.3s",
    overflow: "hidden",
    minHeight: "100vh",
  }}
>
      <div
        className="d-flex align-items-center justify-content-between mb-3"
        onClick={() => setCollapsed(!collapsed)}
        style={{ cursor: "pointer" }}
      >
        <h4 className="m-0 text-center w-100">
          {collapsed ? <i className="bi bi-list"></i> : "Seraphine"}
        </h4>
      </div>

      <ul className="nav nav-pills flex-column mb-auto">
        {/* Empresa */}
        <li className="nav-item">
          <div
            className="nav-link d-flex justify-content-between"
            style={{ cursor: "pointer" }}
            onClick={() => handleToggle("Company")}
          >
            <div>
              <i className="bi bi-people-fill me-2"></i> {!collapsed && "Empresa"}
            </div>
            <i
              className={`bi ${
                OpenCompany ? "bi-chevron-up" : "bi-chevron-down"
              }`}
            ></i>
          </div>
          {OpenCompany && !collapsed && (
            <ul className="nav flex-column ms-3">
              <li className="nav-item">
                <Link to="/company" className="nav-link">
                  <i className="bi bi-building me-2"></i> Empresa
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/sucursales" className="nav-link">
                  <i className="bi bi-shop me-2"></i> Sucursales
                </Link>
              </li>
                   <li className="nav-item">
                <Link to="/empleados" className="nav-link">
                  <i className="bi bi-person-badge me-2"></i> Empleados
                </Link>
              </li>
            </ul>
          )}
        </li>
        

      {/* Horario */}
        <li className="nav-item">
          <div
            className="nav-link d-flex justify-content-between"
            style={{ cursor: "pointer" }}
            onClick={() => handleToggle("Horario")}
          >
            <div>
              <i className="bi bi-calendar-event me-2"></i> {!collapsed && "Horarios"}
            </div>
            <i
              className={`bi ${
                openHorario ? "bi-chevron-up" : "bi-chevron-down"
              }`}
            ></i>
          </div>
          {openHorario && !collapsed && (
            <ul className="nav flex-column ms-3">
              <li className="nav-item">
                <Link to="/horario" className="nav-link">
                  <i className="bi bi-clock me-2"></i> Horarios
                </Link>
              </li>
         
                  <li className="nav-item">
                <Link to="/turno" className="nav-link">
                  <i className="bi bi-briefcase me-2"></i> Turnos
                </Link>
              </li>
            </ul>
          )}
        </li>

        {/* Configuración */}
        <li className="nav-item">
          <div
            className="nav-link d-flex justify-content-between"
            style={{ cursor: "pointer" }}
            onClick={() => handleToggle("settings")}
          >
            <div>
              <i className="bi bi-gear me-2"></i> {!collapsed && "Configurar"}
            </div>
            <i
              className={`bi ${
                openSettings ? "bi-chevron-up" : "bi-chevron-down"
              }`}
            ></i>
          </div>
          {openSettings && !collapsed && (
            <ul className="nav flex-column ms-3">
              <li className="nav-item">
                <Link to="/dispositivo" className="nav-link">
                  <i className="bi bi-hdd-network me-2"></i> Dispositivos
                </Link>
              </li>
         
                  <li className="nav-item">
                <Link to="/comandosPendientes" className="nav-link">
                  <i className="bi bi-terminal me-2"></i> Comandos
                </Link>
              </li>
            </ul>
          )}
        </li>

        {/* Reportes */}
        <li className="nav-item">
          <div
            className="nav-link d-flex justify-content-between"
            style={{ cursor: "pointer" }}
            onClick={() => handleToggle("report")}
          >
            <div>
              <i className="bi bi-bar-chart-line me-2"></i> {!collapsed && "Reportes"}
            </div>
            <i
              className={`bi ${
                openReport ? "bi-chevron-up" : "bi-chevron-down"
              }`}
            ></i>
          </div>
          {openReport && !collapsed && (
            <ul className="nav flex-column ms-3">
              <li className="nav-item">
                <Link to="/reporte" className="nav-link">
                  <i className="bi bi-clipboard-data me-2"></i> Reporte
                </Link>
              </li>
            </ul>
          )}
        </li>
      </ul>

      {/* Botón de cerrar sesión */}
      {!collapsed && (
        <button
          className="btn btn-danger w-100 mt-3"
          onClick={handleLogout}
        >
          <i className="bi bi-box-arrow-right me-2"></i> Cerrar sesión
        </button>
      )}

      {/* Botón de colapsar */}
      <button
        className="btn btn-outline-secondary w-100 mt-2"
        onClick={() => setCollapsed(!collapsed)}
      >
        <i className={`bi ${collapsed ? "bi-chevron-right" : "bi-chevron-left"}`}></i>
      </button>
    </div>
  );
}

export default Sidebar;
